import type { Issue } from '@/lib/api/newsletter';
const sent = new Set<string>();
let session: string | undefined;
export function newsletterAnalyticsAllowed() {
  try {
    return localStorage.getItem('newsletter-analytics-consent') === 'all';
  } catch {
    return false;
  }
}
export function recordNewsletterMetric(
  issue: Issue,
  kind: 'view' | 'source_click',
  sourceUrl = '',
) {
  if (
    issue.status !== 'published' ||
    !newsletterAnalyticsAllowed() ||
    document.visibilityState !== 'visible'
  )
    return;
  const key = [issue.id, kind, sourceUrl].join('|');
  if (sent.has(key)) return;
  session ||= crypto.randomUUID();
  sent.add(key);
  // A transient tab identifier, never associated with an email address or subscriber.
  const url =
    import.meta.env.VITE_SUPABASE_URL + '/functions/v1/newsletter-metrics';
  void fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    keepalive: true,
    body: JSON.stringify({
      issueId: issue.id,
      kind,
      sourceUrl,
      session,
      consent: true,
    }),
  }).catch(() => {
    sent.delete(key);
  });
}
